module.exports = __webpack_public_path__ + "img/right1@2x.70efb09d.png";